// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8353":"00731c10","8355":"03f55591","8845":"404c698e","8977":"d9220130","9537":"1ca18c6b"}[chunkId] + ".chunk.css";
};